export default {
	title: 'humidity_automation',
	components: [{ title: 'humidity_automation', component: 'ext_humidity_actions' }],
};
